// Livello di presentazione della classificazione clienti (solo visivo, calcolo invariato).

// 3 macro-stati commerciali (semplificazione degli 8 stati calcolati)
export const MACRO_STATO = {
  prioritario: { label: "Prioritario", cls: "bg-red-500/15 text-red-400 border-red-500/40" },
  mantenimento: { label: "Mantenimento", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40" },
  riattivazione: { label: "Riattivazione", cls: "bg-amber-500/15 text-amber-400 border-amber-500/40" },
};

const STATO_TO_MACRO = {
  a_rischio: "prioritario", opportunita: "prioritario", strategico: "prioritario",
  in_crescita: "mantenimento", rallentamento: "mantenimento", consolidato: "mantenimento", ordinario: "mantenimento",
  da_riattivare: "riattivazione",
};

export const statoMacro = (stato) => MACRO_STATO[STATO_TO_MACRO[stato]] || null;

// Matrice 2×2: Valore (potential A/B = alto, C = basso) × Attività (engagement alto/medio = alta, basso = bassa)
export const QUADRANTS = {
  chiave: { label: "Clienti chiave", desc: "alto valore · attivo", cls: "bg-[#FDD003] text-black", hex: "#FDD003" },
  sviluppare: { label: "Da sviluppare", desc: "alto valore · poco attivo", cls: "bg-[#F97316] text-white", hex: "#F97316" },
  mantenere: { label: "Da mantenere", desc: "valore contenuto · attivo", cls: "bg-[#14B8A6] text-white", hex: "#14B8A6" },
  marginali: { label: "Marginali", desc: "valore contenuto · poco attivo", cls: "bg-[#64748B] text-white", hex: "#64748B" },
};

export const matrixQuadrantKey = (pr, cat) => {
  const c = cat || pr?.categoria_auto;
  const valoreAlto = c === "A" || c === "B";
  const attivitaAlta = ["alto", "medio"].includes(pr?.eng_tier);
  if (valoreAlto && attivitaAlta) return "chiave";
  if (valoreAlto && !attivitaAlta) return "sviluppare";
  if (!valoreAlto && attivitaAlta) return "mantenere";
  return "marginali";
};

export const matrixQuadrant = (pr, cat) => QUADRANTS[matrixQuadrantKey(pr, cat)];
